<template>
    <div class="components-container">
        <table>
            <tr>
                <td class="formTitle titleFont">考试类型</td>
                <td :colspan="colspanNum">
                    <template>
                        <el-radio-group v-model="configForm.examType">
                            <el-radio label="1">普通考试</el-radio>
                            <el-radio label="2">过程性考试</el-radio>
                        </el-radio-group>
                    </template>
                </td>
            </tr>
            <tr>
                <td class="formTitle titleFont">成绩类型</td>
                <td :colspan="colspanNum">
                    <template>
                        <el-radio-group v-model="configForm.scoreType">
                            <el-radio label="1">数字成绩</el-radio>
                            <el-radio label="2">文字成绩</el-radio>
                        </el-radio-group>
                    </template>
                </td>
            </tr>
            <tr>
                <td class="formTitle titleFont">实训成绩</td>
                <td :colspan="colspanNum">
                    <template>
                        <el-radio-group v-model="configForm.hasTraining" @change="handleTrainingChange">
                            <el-radio label="1">有</el-radio>
                            <el-radio label="0">无</el-radio>
                        </el-radio-group>
                    </template>
                </td>
            </tr>
            <tr>
                <td class="formTitle titleFont" rowspan="3">
                    总评计算比例
                </td>
                <td></td>
                <td class="subTitle titleFont">
                    平时
                </td>
                <td class="subTitle titleFont">
                    期中
                </td>
                <td class="subTitle titleFont" v-if="trainingVisible">
                    实训
                </td>
                <td class="subTitle titleFont">
                    期末
                </td>
            </tr>
            <tr>
                <td class="titleFont" style="width:80px;">
                    默认一
                </td>
                <td class="customPercent" :style="{width:inputWidth}">
                    <el-input v-model="configForm.usualRatio_1"
                        oninput="value=value.replace(/[^\d]/g,'')"
                        style="width:100%;">
                        <template slot="append">%</template>
                    </el-input>
                </td>
                <td class="customPercent" :style="{width:inputWidth}">
                   <el-input v-model="configForm.midRatio_1"
                       oninput="value=value.replace(/[^\d]/g,'')"
                       style="width:100%;">
                       <template slot="append">%</template>
                   </el-input>
                </td>
                <td v-if="trainingVisible" class="customPercent" :style="{width:inputWidth}">
                    <el-input v-model="configForm.trainingRatio_1"
                        oninput="value=value.replace(/[^\d]/g,'')"
                        style="width:100%;">
                        <template slot="append">%</template>
                    </el-input>
                </td>
                <td class="customPercent" :style="{width:inputWidth}">
                    <el-input v-model="configForm.finalRatio_1"
                        oninput="value=value.replace(/[^\d]/g,'')"
                        style="width:100%;">
                        <template slot="append">%</template>
                    </el-input>
                </td>
            </tr>
            <tr>
                <td class="titleFont" style="width:80px;">
                    默认二
                </td>
                <td class="customPercent" :style="{width:inputWidth}">
                    <el-input v-model="configForm.usualRatio_2"
                        oninput="value=value.replace(/[^\d]/g,'')"
                        style="width:100%;">
                        <template slot="append">%</template>
                    </el-input>
                </td>
                <td class="customPercent" :style="{width:inputWidth}">
                    <el-input v-model="configForm.midRatio_2"
                        oninput="value=value.replace(/[^\d]/g,'')"
                        style="width:100%;">
                        <template slot="append">%</template>
                    </el-input>
                </td>
                <td v-if="trainingVisible" class="customPercent" :style="{width:inputWidth}">
                    <el-input v-model="configForm.trainingRatio_2"
                        oninput="value=value.replace(/[^\d]/g,'')"
                        style="width:100%;">
                        <template slot="append">%</template>
                    </el-input>
                </td>
                <td class="customPercent" :style="{width:inputWidth}">
                    <el-input v-model="configForm.finalRatio_2"
                        oninput="value=value.replace(/[^\d]/g,'')"
                        style="width:100%;">
                        <template slot="append">%</template>
                    </el-input>
                </td>
            </tr>
            <tr v-if="passStandardConfig">
                <td class="formTitle titleFont">合格标准分</td>
                <td :colspan="colspanNum">
                    <template>
                        <el-input v-model="configForm.passStandardScore"
                            oninput="value=value.replace(/[^\d]/g,'');value=value>100?100:value;" style="width:180px;">
                            <template slot="append">分</template>
                        </el-input>
                    </template>
                </td>
            </tr>
            <tr>
                <td colspan="6" style="height:60px; text-align:center;">
                    <el-button type="primary" @click="save">保存</el-button>
                    <!-- <el-button @click="applyDialogVisible = false">取消</el-button> -->
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    import { confirmMsg, showNotify } from "utils/message";
    import { globalConfig } from "static/config";

    export default {
        data() {
            return {
                configForm: {
                    examType: '1',
                    scoreType: '1',
                    hasTraining: '0',
                    usualRatio_1: null,
                    midRatio_1: null,
                    trainingRatio_1: null,
                    finalRatio_1: null,
                    usualRatio_2: null,
                    midRatio_2: null,
                    trainingRatio_2: null,
                    finalRatio_2: null,
                    passStandardScore: '60',
                },
                trainingVisible: false,
                colspanNum: 4,
                inputWidth: '120px',
                passStandardConfig: false,
            }
        },
        mounted() {
            this.initConifg();
            this.loadDefaultConfig();
        },
        methods: {
            initConifg(){
                this.passStandardConfig = globalConfig.scoreManage.passStandardConfig;
            },
            loadDefaultConfig(){
                this.$api.scoreManage.setting.defaultConfig.query({}).then((res) => {
                    this.configForm = res.data.data;
                }).catch((err) => {
                    console.log(err);
                });
            },
            handleTrainingChange(value){
                if(value === '0'){
                    this.trainingVisible = false;
                    this.colspanNum = 4;
                    this.inputWidth = '120px';
                }else{
                    this.trainingVisible = true;
                    this.colspanNum = 5;
                    this.inputWidth = '90px';
                }
            },
            save(){
                if((parseInt(this.configForm.usualRatio_1==''?0:this.configForm.usualRatio_1)
                    + parseInt(this.configForm.midRatio_1==''?0:this.configForm.midRatio_1)
                    + parseInt(this.configForm.trainingRatio_1==''?0:this.configForm.trainingRatio_1)
                    + parseInt(this.configForm.finalRatio_1==''?0:this.configForm.finalRatio_1))>100
                    || (parseInt(this.configForm.usualRatio_2==''?0:this.configForm.usualRatio_2)
                    + parseInt(this.configForm.midRatio_2==''?0:this.configForm.midRatio_2)
                    + parseInt(this.configForm.trainingRatio_2==''?0:this.configForm.trainingRatio_2)
                    + parseInt(this.configForm.finalRatio_2==''?0:this.configForm.finalRatio_2)>100)){
                   this.$message.warning('比例总和不能超过100%');
                   return;
                }

                this.$api.scoreManage.setting.defaultConfig.save({
                    data: this.configForm,
                }).then((res) => {
                    const state = res.data.data.state;
                    const msg = res.data.data.msg;

                    if(state == 'Success'){
                        showNotify('成功', msg ? msg : "保存成功", 'success', 1500);
                    }else{
                        showNotify('失败', msg ? msg : "保存失败", 'error', 3000);
                    }
                }).catch((err) => {
                    showNotify('错误', err, 'error', 3000);
                });
            },
        },
    }
</script>
<style scoped>
    .formTitle {
        width: 120px;
        height: 40px;
        padding: 0 12px 0 0;
    }

    .titleFont {
        color: #606266;
        font-size: 14px;
        font-weight: 700;
    }

    .subTitle {
        text-align: center;
    }

    /deep/ .ratioInput input::-webkit-out-spin-button,
    /deep/ .ratioInput input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
    /deep/ .ratioInput input[type="number"] {
        -moz-appearance: textfield;
    }

    .customPercent /deep/ .el-input-group__append {
        padding: 0 10px !important;
    }
</style>



// WEBPACK FOOTER //
// defaultConfig.vue?3cb3e6fa